import useAuth from "@/components/auth/useAuth"
import ErrorBoundary from "@/components/util/error/ErrorBoundary"
import React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"

export interface PrivateRouteProps extends RouteProps {
  redirect?: string
}

export function PrivateRoute(props: PrivateRouteProps) {
  const { component: Component, children, redirect, ...rest } = props

  const { user } = useAuth()

  const to = redirect || "/login"

  return (
    <Route
      {...rest}
      render={props => {
        if (!user) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect to={{ pathname: to, state: { from: props.location } }} />
          )
        }

        if (!user?.agreed)
          return (
            <Redirect
              to={{ pathname: "/register", state: { from: props.location } }}
            />
          )

        if (user?.password_reset)
          return (
            <Redirect
              to={{
                pathname: "/passwordreset",
                state: { from: props.location }
              }}
            />
          )

        // authorised so return component
        if (children) return <ErrorBoundary>{children}</ErrorBoundary>

        if (Component) return <Component {...props} />

        return null
      }}
    />
  )
}
